import "@jpj/ui/reset.css";
import "@jpj/ui/components.css";
import "./styles/theme.css";
import "./styles/game.css";

import { $ } from "./dom";
import { hideOverlay, runTeaser } from "@jpj/game-shell";
import { state } from "./game/state";
import { buildBoard, portraitMode } from "./game/board";
import {
  buildDots, goNext, goPrev, recompute, resetLevel, restartGame, startGame, updateNav,
} from "./game/flow";
import { initInteraction } from "./game/interaction";
import { skipCompare, nextCompare } from "./reveal/reveal";
import { openLearn, closeLearn, stepLearn } from "./reveal/learn";

/* ---------- Nav + controls ---------- */
$("prevBtn").addEventListener("click", goPrev);
$("nextBtn").addEventListener("click", goNext);
$("resetBtn").addEventListener("click", resetLevel);

/* ---------- Reveal / explainer buttons (always present in the DOM) ---------- */
$("cmpSkip").addEventListener("click", skipCompare);
$("cmpNext").addEventListener("click", nextCompare);
$("learnBtn").addEventListener("click", openLearn);
$("again2").addEventListener("click", () => {
  hideOverlay("solverOverlay");
  restartGame();
});
$("learnBack").addEventListener("click", closeLearn);
$("lPrev").addEventListener("click", () => stepLearn(-1));
$("lNext").addEventListener("click", () => stepLearn(1));

/* ---------- Intro ---------- */
const beginGame = (): void => {
  hideOverlay("introOverlay");
  startGame();
};
$("beginBtn").addEventListener("click", beginGame);

/* ---------- Orientation ---------- */
// The chart rotates 90° on narrow portrait screens (same instance, bigger
// rendering). Rebuild only when the mode actually flips; plain size changes
// are handled by the SVG scaling itself.
let portrait = portraitMode();
window.addEventListener("resize", () => {
  if (portraitMode() === portrait) return;
  portrait = portraitMode();
  buildBoard();
  recompute();
});

/* ---------- Init ---------- */
// the title scene stays up until the player picks "How to Play" or "Start"
runTeaser({ onStart: beginGame });
initInteraction();
buildDots();
// preload the first chart behind the intro so it looks ready
state.idx = 0;
buildBoard();
recompute();
updateNav();
